/* eslint-disable react/prop-types */
import React from 'react';

const HrEmploymentCard = ({ data }) => {
  if (!data) {
    return null;
  }

  const { personal_information, professional_details } = data;
  return (
    <React.Fragment>
      <style>
        {`
        body {
        font-family: Arial, sans-serif;
        margin: 0;
        padding: 8px;
        font-size: 11px;
        line-height: 1.3;
      }
      .container {
        max-width: 800px;
        margin: 0 auto;
      }
      .card-container .card {
        border: 1px solid #000;
        padding: 12px;
        margin-bottom: 10px;
        background-color: white;
      }
      .header {
        text-align: center;
        margin-bottom: 15px;
      }
      .form-number {
        text-align: right;
        font-weight: bold;
        margin-bottom: 8px;
        font-size: 12px;
      }
      .form-title {
        text-align: center;
        margin-bottom: 3px;
        font-weight: bold;
      }
      .form-subtitle {
        text-align: center;
        margin-bottom: 8px;
        font-size: 10px;
      }
      .main-title {
        font-weight: bold;
        font-size: 16px;
        text-decoration: underline;
        margin-bottom: 15px;
        text-align: center;
      }
      .field-row {
        display: flex;
        margin-bottom: 6px;
        align-items: baseline;
      }
      .field-label {
        font-weight: normal;
      }
      .field-value {
        flex: 1;
        border-bottom: 1px solid #000;
        padding-bottom: 1px;
        margin-left: 5px;
        text-align: center;
        font-weight: bold;
      }
      .numbered-field {
        margin-bottom: 6px;
      }
      .signature-section {
        margin-top: 40px;
        display: flex;
        justify-content: space-between;
      }
      .signature-box {
        text-align: center;
        width: 200px;
      }
      .separator {
        border-top: 2px dashed #000;
        margin: 20px 0;
      }
      .print-button {
        position: fixed;
        top: 20px;
        right: 20px;
        padding: 10px 20px;
        background-color: #4caf50;
        color: white;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        font-size: 16px;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
        z-index: 1000;
      }
      .print-button:hover {
        background-color: #45a049;
      }

      /* Print specific styles */
      @media print {
        body {
          margin: 0;
          padding: 0;
          background-color: white;
          font-size: 10px;
        }
        .container {
          max-width: 100%;
          margin: 0;
        }
        .card-container .card {
          border: 1px solid #000;
          padding: 8px;
          margin-bottom: 5px;
        }
        .print-button {
          display: none;
        }
        .separator {
          margin: 10px 0;
        }
        @page {
          size: A4;
          margin: 0.5cm;
        }
      }
        `}
      </style>
      <div className="container card-container">
        {/* First Employment Card */}
        <EmployeeCard
          key={'employeeCard1'}
          personal_information={personal_information}
          professional_details={professional_details}
        />
        <div className="separator" />
        {/* Second Employment Card (Duplicate) */}
        <EmployeeCard
          key={'employeeCard2'}
          personal_information={personal_information}
          professional_details={professional_details}
        />
      </div>
    </React.Fragment>
  );
};

const EmployeeCard = ({ personal_information, professional_details }) => {
  return (
    <div className="card">
      <div className="header">
        <div className="form-title">FORM X</div>
        <div className="form-subtitle">(See Rule 75)</div>
        <div className="main-title">EMPLOYMENT CARD</div>
      </div>
      <div className="field-row">
        <span className="field-label">Name and address of the Contractor</span>
        <span className="field-value">KALYANI VENTURES LIMITED</span>
      </div>
      <div
        style={{
          textAlign: 'center',
          marginBottom: 8,
          borderBottom: '1px solid #000',
          paddingBottom: 1
        }}
      >
        <strong>
          MEHERPADA, BIJU PATTNAIK CHOWK, BADMAL, P.O.- BADMAL, DIST.-
          JHARSUGUDA, ODISHA-768202
        </strong>
      </div>
      <div className="field-row">
        <span className="field-label">
          Name and address of the Establishment
        </span>
        <span className="field-value">VEDANTA JHARSUGUDA (PLANT-1)</span>
      </div>
      <div
        style={{
          textAlign: 'center',
          marginBottom: 8,
          borderBottom: '1px solid #000',
          paddingBottom: 1
        }}
      >
        <strong>JHARSUGUDA, ODISHA (ORISSA)-768202</strong>
      </div>
      <div className="field-row">
        <span className="field-label">Nature and Location of Work</span>
        <span className="field-value">POT LINE (POT RELINING)</span>
      </div>
      <div className="field-row">
        <span className="field-label">
          Establishment in/under which contract is carried on
        </span>
        <span className="field-value">VEDANTA JHARSUGUDA (PLANT-1)</span>
      </div>
      <div className="field-row">
        <span className="field-label">
          Name and address of Principal Employer
        </span>
        <span className="field-value">VEDANTA JHARSUGUDA (PLANT-1)</span>
      </div>
      <div
        style={{
          textAlign: 'center',
          marginBottom: 15,
          borderBottom: '1px solid #000',
          paddingBottom: 1
        }}
      >
        <strong>JHARSUGUDA, ODISHA (ORISSA)-768202</strong>
      </div>
      <div className="numbered-field">
        <div className="field-row">
          <span className="field-label">1. Name of the workman</span>
          <span className="field-value">
            {personal_information.first_name} {personal_information.last_name}{' '}
            (EMPLOYEE CODE: {personal_information.employee_unique_id})
          </span>
        </div>
      </div>
      <div className="numbered-field">
        <div className="field-row">
          <span className="field-label">
            2. Sl. No of the register of workman employed
          </span>
          <span className="field-value">
            {personal_information.employee_unique_id
              ?.split('/')[2]
              .padStart(3, '0')}
          </span>
        </div>
      </div>
      <div className="numbered-field">
        <div className="field-row">
          <span className="field-label">
            3. Nature of employment designation
          </span>
          <span className="field-value">
            {professional_details.designation_name}
          </span>
        </div>
      </div>
      <div className="numbered-field">
        <div className="field-row">
          <span className="field-label">
            4. Wage rate (with particulars of unit) in case of piece work
          </span>
          <span className="field-value"></span>
        </div>
      </div>
      <div className="numbered-field">
        <div className="field-row">
          <span className="field-label">5. Wage period</span>
          <span className="field-value">MONTHLY</span>
        </div>
      </div>
      <div className="numbered-field">
        <div className="field-row">
          <span className="field-label">6. Period of employment</span>
          <span className="field-value">
            {professional_details.date_of_joining} to
          </span>
        </div>
      </div>
      <div className="numbered-field">
        <div className="field-row">
          <span className="field-label">7. Remarks</span>
          <span className="field-value" style={{ minHeight: 20 }} />
        </div>
      </div>
      <div className="signature-section">
        <div className="signature-box">
          <div>Signature or thumb impression of Employee</div>
        </div>
        <div className="signature-box">
          <div>Signature of Contractor</div>
          <div style={{ marginTop: 10, fontWeight: 'bold' }}>
            Kalyani Ventures Limited
          </div>
        </div>
      </div>
    </div>
  );
};

export default HrEmploymentCard;
